module.exports = "//static.hsappstatic.net/ContentUtils/static-1.60430/img/choiceButtons/layout-tiles.svg"